import React, { useState, useEffect, useRef } from "react";
import {
    Navbar,
    Container,
    Row,
    Col,
    Card,
    Button,
    Form,
    Toast,
    InputGroup,
} from "react-bootstrap";
import { MdDelete } from "react-icons/md";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import "../style/admin.css";
import Spinner from "react-bootstrap/Spinner";
import axios from "axios";
import { GrCart } from "react-icons/gr";
import Offcanvas from "react-bootstrap/Offcanvas";
import { RxHamburgerMenu } from "react-icons/rx";
import { useContext } from "react";
import { CartContext } from "./CartContext";
import { apibasePath } from "../config";
import { Fade as Hamburger } from "hamburger-react";

import { motion } from "framer-motion";
import LoadingItemsGrid from "../shared/LoadingItemsGrid";
import LoadingImg from "../shared/LoadingImg";
import ProductTags from "../shared/ProductTags";
import { ProductsListContext } from "../context/ProductsListsContext";
import { MdLogout } from "react-icons/md";
import LogoutModal from "../shared/LogoutModal";
import { addToCart,  cartCountfeatchData,  DeleteByTag, fetchCart, fetchCustonerItems, fetchOrderStockSizes, fetchReadyStock, fetchReadyStockSizes, GetBrandDetails, GetCompanyDetails } from "../APICalls";
import useMedia from "use-media";
import { FaHome } from "react-icons/fa";

const Slide = () => {
    const [itemData, setItemData] = useState([]);

    const [displayData, setDisplayData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [selectedItem, setSelectedItem] = useState("");
    const [showSidebar, setShowSidebar] = useState(false);
    const [showTabSidebar, setShowTabSidebar] = useState(true);

    const [brandLogo, setBrandLogo] = useState(null);
    const [CartsCounts, setCartsCounts] = useState([]);

    const [AllSizes, setAllSizes] = useState([]);

    const [logo, setLogo] = useState(null);
    const [name, setName] = useState("");
    const [sizes, setSizes] = useState([]);

    const [selectProduct, setSelectProduct] = useState(false);

    const [searchParams, setSearchParams] = useSearchParams();
    const [toast, setToast] = useState(false);
    const navigate = useNavigate();
    const handleSidebarClose = () => setShowSidebar(false);
    const handleSidebarShow = () => setShowSidebar(true);

    const isLGDevice = useMedia('min-width:900px');



    const [showLogoutModal, setShowLogoutModal] = useState(false)

    const location = useLocation();
    const { ProductsAPI, sizesAPI } = useContext(ProductsListContext);

    const [shouldApplyFilters, setShouldApplyFilters] = useState(false);

    const token = localStorage.getItem("token");

    const naviagate = useNavigate()

    const [filters, setFilters] = useState({
        gross_weight_min: "",
        gross_weight_max: "",
        net_weight_min: "",
        net_weight_max: "",
        stone_weight_min: "",
        stone_weight_max: "",
        size_min: "",
        size_max: "",
    });

    const [companyDetails, setCompanyDetails] = useState('')

    const fetchCompanyDetails = async () => {
        const data = await GetCompanyDetails();
        if (data.error) {
            toast.error("Failed to Fetch Company Details");
            return;
        }
        setCompanyDetails(data);
        setLogo(data?.logo);
        setName(data?.name);
    };
    const fetchBrand = async () => {
        const data = await GetBrandDetails();
        if (data.error) {
            console.log("Error Fetching")
        }
        setBrandLogo(data.logo);
    };

    useEffect(() => {

        if (!token) {
            navigate('/')
        }

        fetchCartItems();
        fetchCompanyDetails();
        fetchBrand();

    }, []);

    useEffect(() => {
        const updatedFilters = {};
        // console.log(filters)

        Object.keys(filters).forEach((key) => {
            if (searchParams.has(key)) {
                updatedFilters[key] = searchParams.get(key);
            } else {
                updatedFilters[key] = "";
            }
        });
        for (const [key, val] of searchParams.entries()) {
            if (!filters[key]) {
                updatedFilters[key] = val;
            }
        }


        setFilters(updatedFilters);

        if (searchParams.has("product")) {
            setSelectProduct(true);

            setSelectedItem(searchParams.get("product")?.replace("%2C", ",").split(","));
        } else {
            const allItemCodes = itemData?.map((item) => item.item_code);
            setSelectedItem(allItemCodes);
            fetchMultipleData(allItemCodes);
        }

        if (searchParams.has("size")) {
            setAllSizes(searchParams.get("size")?.replace("%2C", ",").split(","));

        } else {
            setAllSizes([]);
        }


        //backend
        // console.log(searchParams.toString())

        const callAPIWithParams = async (searchParams) => {
            const Token = localStorage.getItem("token");


            const url = `${apibasePath}/client/customer-stock-multiple-items/?${searchParams.toString()}`;

            const response = await fetch(url, {
                method: "POST",
                headers: {
                    Authorization: `bearer ${Token}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    customer_items: searchParams.get("product")?.replace("%2C", ",").split(","),
                }),
            });

            if (!response.ok) {
                setLoading(false);
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            setDisplayData(data?.results);
        }

        searchParams.has("product") && callAPIWithParams(searchParams)


        setShouldApplyFilters(true);
    }, [location.search]);

    // useEffect(() => {
    //     if (shouldApplyFilters) {
    //         setShouldApplyFilters(false);
    //         setToast(false);
    //     }
    // }, [filters, shouldApplyFilters]);

    useEffect(() => {
        fetchCusomterItems();
    }, [searchParams]);

    const fetchCusomterItems = async () => {
        const data = await fetchCustonerItems();
        if (data.error) {
            console.log("error", data.error);
        }
        setItemData(data);
    };


    ///cart details
    const fetchCartItems = async () => {
        const data = await fetchCart();
        if (data?.error) {
            console.log("Error Fetching Cart", data.error)
        }
    };

    const scrollContainerRef = useRef(null);

    const saveScrollPosition = () => {
        if (scrollContainerRef.current) {
            localStorage.setItem("containerScrollPosition", scrollContainerRef.current.scrollTop.toString());
        }
    };

    const handleGoToCart = () => {
        saveScrollPosition();
        navigate("/add-to-cartdetails");
    };

    const handleNavigateToProduct = (productId) => {
        saveScrollPosition();
        navigate(`/customer-items/${productId}`);
    };

    useEffect(() => {
        fetchCartCount();
        const restoreScrollPosition = () => {
            const savedPosition = localStorage.getItem("containerScrollPosition");
            if (
                savedPosition &&
                scrollContainerRef.current &&
                displayData?.length > 0
            ) {
                // Use requestAnimationFrame for smoother restoration
                requestAnimationFrame(() => {
                    scrollContainerRef.current.scrollTop = parseInt(savedPosition, 10);
                    localStorage.removeItem("containerScrollPosition");
                });
            }
        };
        const timer = setTimeout(restoreScrollPosition, 50);
        return () => clearTimeout(timer);

    }, [displayData]);


    const fetchMultipleData = async (item_code) => {

        const params = searchParams;

        const Token = localStorage.getItem("token");
        console.log(params.toString())
        try {
            const response = await axios.post(
                `${ProductsAPI}?${params.toString()}`,
                { customer_items: item_code },
                {
                    headers: {
                        Authorization: `bearer ${Token}`,
                        "Content-Type": "application/json",
                    },
                }
            );
            setDisplayData(response.data.results);
        } catch (error) {
            console.log("Error fetching multiple data", error);
        }
    };


    const fetchCartCount = async () => {

        const data = await cartCountfeatchData();
        if (data.error) {
            console.log("Error fetching sizes:", data.error);
            return;
        }
        setCartsCounts(data?.cart_count);
    };


    const navigateWithFilters = () => {
        const params = new URLSearchParams(searchParams);
        // console.log(filters)

        Object.keys(filters).forEach((field) => {
            if (filters[field] != null && filters[field] !== "") {
                params.set(field, filters[field]);
            } else {
                params.delete(field);
            }
        });

        if (AllSizes.length > 0) {
            params.set("size", AllSizes.join(","));
        }

        if (selectedItem?.length > 0) {
            setSelectProduct(true);
        }
        // console.log(params)

        navigate(`/mydesigns?${params.toString()}`);
        // navigate(`/mydesigns?${params.toString()}`, { replace: true });

    }

    useEffect(() => {
        const debounceTimer = setTimeout(() => {
            // applyFilters();
        }, 30); // 300ms delay

        return () => clearTimeout(debounceTimer);
    }, [filters, AllSizes]);

    const clearFilters = async () => {
        // setLoading(true);
        const cleared = {
            gross_weight_min: "",
            gross_weight_max: "",
            net_weight_min: "",
            net_weight_max: "",
            stone_weight_min: "",
            stone_weight_max: "",
            size: "",
        };

        setFilters(cleared);
        setAllSizes([]);

        localStorage.removeItem("selectedSizes");
        Object.keys(cleared).forEach((key) => {
            localStorage.removeItem(key);
        });

        // Clear input fields directly if they exist in the DOM
        document.querySelectorAll('input[type="number"]').forEach((input) => {
            if (
                input.name === "gross_weight_min" ||
                input.name === "gross_weight_max" ||
                input.name === "net_weight_min" ||
                input.name === "net_weight_max" ||
                input.name === "stone_weight_min" ||
                input.name === "stone_weight_max"
            ) {
                input.value = "";
            }
        });

        document
            .querySelectorAll("input[type=checkbox]")
            .forEach((el) => (el.checked = false));

        const sizeInput = document.querySelector('input[name="size"]');
        if (sizeInput) {
            sizeInput.value = "";
        }

        // Remove "size" from URL
        const params = new URLSearchParams(window.location.search);
        params.delete("size");
        params.delete("gross_weight_min");
        params.delete("gross_weight_max");
        params.delete("net_weight_min");
        params.delete("net_weight_max");
        params.delete("stone_weight_min");
        params.delete("stone_weight_max");

        // Preserve other params like "Product", "category", etc. (optional)
        const updatedQuery = params.toString();
        const navigateTo = `/mydesigns${updatedQuery ? "?" + updatedQuery : ""}`;


        navigate(navigateTo);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFilters((prevFilters) => ({ ...prevFilters, [name]: value }));
    };

    // useEffect(()=> {
    //     console.log(filters)
    // },[filters] )


    const handleCheckNewCheckBox = async (event) => {
        const { value, checked } = event.target;

        // console.log("val", value)

        // Immediate UI update (optimistic update)
        setSelectedItem((prevSelected) => {
            const updated = checked
                ? [...prevSelected, value]
                : prevSelected.filter((item) => item !== value);
            return updated;
        });

        try {
            const params = new URLSearchParams(searchParams);

            const newSelection = checked
                ? [...selectedItem, value]
                : selectedItem.filter((item) => item !== value);

            if (newSelection.length > 0) {
                params.set("product", newSelection.join(","));
            } else {
                params.delete("product");
            }

            await Promise.all([
                // fetchMultipleData(newSelection),
                fetchCartCount(),
                navigate(`/mydesigns?${params.toString()}`),
            ]);
        } catch (error) {
            console.log("Error in checkbox handler:", error);

            setSelectedItem(selectedItem);
        }
    };

    useEffect(() => {
        const params = new URLSearchParams();
        if (selectedItem.length > 0) {
            params.set("product", selectedItem.join(","));
        } else {
            params.delete("product");
        }
    }, [selectedItem, setSearchParams]);



    const handleCheckBoxAll = (event) => {
        const { checked } = event.target;

        if (checked) {
            const allItemCodes = itemData?.map((item) => item.item_code);
            setSelectedItem(allItemCodes);
            fetchMultipleData(allItemCodes);
            const params = searchParams;
            params.delete('product');
            navigate(`/mydesigns?${params.toString()}`);

        } else {
            setSelectedItem([]);
            fetchMultipleData([]);
        }
    };


    const handleCheckBoxChange = (event) => {
        const { name, checked, value } = event.target;
        if (name === "size") {
            setAllSizes((prev) =>
                checked ? [...prev, value] : prev.filter((size) => size !== value)
            );
        }
    };


    const fetchSizeData = async () => {

        if (sizesAPI.includes('order')) {
            const data = await fetchOrderStockSizes();
            if (data?.error) {
                console.log("Error Adding to Cart", data.error);
                return;
            }

            setSizes(data);
        } else {
            if (!selectedItem) return;
            const data = await fetchReadyStockSizes({ item_codes: selectedItem });
            if (data?.error) {
                console.log("Error Adding to Cart", data.error);
                return;
            }
            setSizes(data);
        }
    };

    useEffect(() => {
        fetchSizeData();
    }, [selectedItem, sizesAPI]);

    const { cartItems, setCartItems } = useContext(CartContext);

    const handleCartAction = async (product) => {

        const data = await addToCart(product);
        if (data?.error) {
            console.log("Error Adding to Cart", data.error);
            return;
        }

        const newCart = [...cartItems, product.item_tag];
        setCartItems(newCart);
        fetchCartItems();
        fetchCartCount();
        setLoading(false);
    };

    const handleCartActionDelete = async (product) => {
        try {
            const isInCart = cartItems.includes(product.item_tag);

            if (isInCart) {
                await DeleteByTag({ item_tag: product.item_tag });

                fetchCartItems();
                fetchCartCount();
                setCartItems((prevItems) =>
                    prevItems.filter((item) => item !== product.item_tag)
                );
            }
        } catch (error) {
            console.log("Cart action failed:", error);
        }
    };


    const [firstAllSelectDone, setFirstAllSelectDone] = useState(false);

    useEffect(() => {
        if (
            itemData?.length > 0 &&
            !searchParams.has("size") &&
            !searchParams.has("product") &&
            !firstAllSelectDone
        ) {
            handleCheckBoxAll({ target: { checked: true, }, });
            setFirstAllSelectDone(true);
        }
    }, [itemData, searchParams]);


    const handleContextMenu = (event) => {
        event.preventDefault();
    };

    const isMDDevice = useMedia('(min-width:992px)')

    if (loading) {
        return (
            <div
                style={{
                    top: "50%",
                    left: "50%",
                    translate: ("-50%", "-50%"),
                    position: "absolute",
                }}
                className="slide"
            >
                <Spinner animation="border" role="status" variant="primary">
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
            </div>
        );
    }


    return (
        <div className="slide">

            <Navbar className="bg-body-tertiary fixed-top " expand="md">
                <Container fluid>
                    <Navbar.Brand>
                        {/* <div
                            style={{
                                width:   "100px" ,
                                height: isMDDevice? "50px" : '20px',
                                borderRadius: "10px",
                                overflow: "hidden",
                            }}
                        >
                        </div> */}
                        <img
                            src={logo}
                            alt="companylogo"
                            // class="img-fluid"
                            style={{ width: "70px", height: "50px", }}
                        />
                    </Navbar.Brand>
                    <Navbar.Brand
                        style={{
                            color: "#23395B",
                            fontFamily: "Roboto",
                            fontWeight: "600",
                            marginRight: "auto",
                            fontSize: "17px",
                            opacity: 0,
                        }}
                        className="d-none d-sm-block"
                    >
                        {name}
                    </Navbar.Brand>

                    <Navbar.Brand
                        style={{
                            color: "#23395B",
                            fontFamily: "Roboto",
                            fontWeight: "600",
                            marginRight: "auto",
                            fontSize: "17px",
                        }}
                    >
                        Shopping Cart
                    </Navbar.Brand>

                    <div
                        // style={{ marginRight: '10px' }}
                        className="d-flex align-items-center   gap-2  "
                    >

                        <div
                        //  style={{ marginRight: "20%" }}
                        >
                            <Navbar.Brand
                                className="home d-none d-sm-block"
                                style={{
                                    color: "#23395B",
                                    fontFamily: "Roboto",
                                    fontWeight: "600",
                                    marginRight: "auto",
                                    fontSize: "17px",
                                }}
                            >
                                <a
                                    href="/mydesigns"
                                    style={{
                                        textDecoration: "none",
                                        color: "#23395B",
                                        fontfamily: "Roboto",
                                    }}
                                >
                                    Home
                                </a>
                            </Navbar.Brand>
                            <Navbar.Brand
                                className="home d-block d-sm-none"
                                style={{
                                    color: "#23395B",
                                    fontFamily: "Roboto",
                                    fontWeight: "600",
                                    marginRight: "10px",
                                    fontSize: "26px",
                                }}
                            >
                                <a
                                    href="/mydesigns"
                                    style={{
                                        textDecoration: "none",
                                        color: "#23395B",
                                        fontfamily: "Roboto",
                                    }}
                                >
                                    <FaHome />
                                </a>
                            </Navbar.Brand>
                        </div>

                        <Navbar.Brand className="">
                            <div
                                onClick={handleGoToCart}
                                style={{ position: "relative" }}
                            >
                                <GrCart
                                    style={{ width: "30px", height: "30px", color: "#396D72" }}
                                />

                                {CartsCounts > 0 && (
                                    <span
                                        style={{
                                            position: "absolute",
                                            top: "-5px",
                                            right: "-5px",
                                            backgroundColor: "red",
                                            color: "white",
                                            borderRadius: "50%",
                                            padding: "4px 7px",
                                            fontSize: "12px",
                                        }}
                                    >
                                        <h1 style={{ fontSize: "12px", margin: 0 }}>
                                            {CartsCounts}
                                        </h1>
                                    </span>
                                )}
                            </div>


                        </Navbar.Brand>
                        <Navbar.Brand className="logout" style={{ marginRight: '28px' }} >

                            <MdLogout onClick={() => setShowLogoutModal(true)} fontSize={25} color="#000" />
                            <LogoutModal show={showLogoutModal} onHide={() => setShowLogoutModal(false)} />
                        </Navbar.Brand>
                    </div>
                </Container>
            </Navbar>



            <div style={{ display: 'flex' }} >

                {/* Offcanvas Sidebar for Mobile */}
                <div className="d-md-none" >
                    <Offcanvas
                        show={showSidebar}
                        onHide={handleSidebarClose}
                        placement="start"
                    >
                        <Offcanvas.Header
                            className="custom-offcanvas-header"
                            variant="light"
                            // closeButton
                            style={{ backgroundColor: "#396D72", color: "#fff" }}
                        >
                            <Offcanvas.Title>Menu</Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body style={{ backgroundColor: "#396D72" }}>
                            <div
                                style={{
                                    // backgroundColor: "#396D72",
                                    border: "none",
                                    // fontSize: "20px",
                                    color: "#fff",
                                    marginLeft: "30px",
                                    fontFamily: "Roboto",
                                }}
                                id="mobile-products-sidebar"
                            // className="mt-5"
                            >
                                <div
                                    className="d-flex align-items-center justify-content-between "
                                    style={{
                                        border: "none",
                                        fontSize: "20px",
                                        color: "#fff",
                                        fontFamily: "Roboto",
                                    }}
                                >
                                    <p className="mb-0">Products</p>
                                    <Hamburger
                                        toggled={showSidebar} onToggle={() => {
                                            setShowSidebar(prev => !prev)
                                        }} direction="right"
                                        size={20} />
                                </div>
                                <Form.Check
                                    type="checkbox"
                                    onChange={handleCheckBoxAll}
                                    checked={
                                        selectedItem.length === itemData.length &&
                                        itemData.length > 0
                                    }
                                    value=""
                                    id="checkbox"
                                    label="Select All Products"
                                    htmlFor="checkbox"
                                    className="mb-2 transparent-checkbox"
                                    onClick={(e) => e.stopPropagation()}
                                    style={{ cursor: "pointer" }}
                                />

                                { itemData?.length > 0 && itemData?.map((item, index) => (
                                    <Form.Check
                                        key={item?.item_code}
                                        type="checkbox"
                                        onChange={(e) => {
                                            handleCheckNewCheckBox(e);
                                        }}
                                        checked={selectedItem.includes(item.item_code)}
                                        name="itemName"
                                        id={`item-name-${index}`}
                                        value={item.item_code}
                                        label={item.item_name}
                                        htmlFor={`item-name-${index}`}
                                        className="mb-2 transparent-checkbox d-flex"
                                        onClick={(e) => e.stopPropagation()}

                                    />
                                ))}
                            </div>

                            {/* filters */}
                            <div>
                                <Form style={{ paddingTop: "20px" }}>
                                    <Form.Group>
                                        <Form.Label
                                            style={{
                                                color: "#fff",
                                                fontfamily: "Roboto",
                                                fontWeight: "500",
                                                lineHeight: "1.2",
                                                letterSpacing: "0",
                                                fontSize: "20px",
                                            }}
                                        >
                                            Size
                                        </Form.Label>{" "}
                                        <br />
                                        <div
                                            className="checks"
                                            style={{
                                                display: "flex",
                                                color: "#fff",
                                                justifyContent: "space-between",
                                                backgroundColor: "transparent",
                                            }}
                                        >
                                            <div
                                                className="row"
                                                style={{
                                                    marginLeft: "2px",
                                                }}
                                            >
                                                {sizes.length > 0 && sizes.map((size, index) => (
                                                    <Form.Check
                                                        key={index}
                                                        type="checkbox"
                                                        onChange={handleCheckBoxChange}
                                                        checked={AllSizes.includes(`${size}`)}
                                                        name="size"
                                                        id={`size-checkbox-${index}`}
                                                        htmlFor={`size-checkbox-${index}`}
                                                        value={size}
                                                        label={size}
                                                        className="mb-2 transparent-checkbox col-4"
                                                    />
                                                ))}
                                            </div>
                                        </div>
                                    </Form.Group>
                                    {/* Gross Weight */}
                                    <Form.Group style={{ paddingTop: "10px" }}>
                                        <Form.Label
                                            style={{
                                                color: "white",
                                                fontSize: "20px",
                                                fontFamily: "Poppins",
                                            }}
                                        >
                                            Gross Weight
                                        </Form.Label>
                                        <div style={{ display: "flex", maxWidth: '220px' }}>
                                            <InputGroup className="position-relative ">
                                                <Form.Control
                                                    type="number"
                                                    style={{
                                                        backgroundColor: "transparent",
                                                        color: "#fff",
                                                        borderRadius: "3px",
                                                    }}
                                                    name="gross_weight_min"
                                                    placeholder="Min"
                                                    value={filters.gross_weight_min}
                                                    onChange={handleInputChange}
                                                    onBlur={() => navigateWithFilters()}
                                                    onWheel={(e) => e.target.blur()}
                                                    onKeyDown={(e) => {
                                                        if (["ArrowUp", "ArrowDown"].includes(e.key)) {
                                                            e.preventDefault();
                                                        }
                                                        if (e.key === "Enter") {
                                                            navigateWithFilters();
                                                        }
                                                    }}
                                                />

                                                <span className=" fs-3 position-absolute" style={{ right: 5, top: '0px', color: '#c1bfbf' }} >↵</span>

                                            </InputGroup>
                                            <InputGroup className="position-relative ">
                                                <Form.Control
                                                    type="number"
                                                    name="gross_weight_max"
                                                    value={filters.gross_weight_max}
                                                    placeholder="Max"
                                                    onChange={handleInputChange}
                                                    onBlur={() => navigateWithFilters()} // Trigger when field loses focus
                                                    onWheel={(e) => e.target.blur()}
                                                    onKeyDown={(e) => {
                                                        if (["ArrowUp", "ArrowDown"].includes(e.key)) {
                                                            e.preventDefault();
                                                        }
                                                        // Trigger on Enter key
                                                        if (e.key === "Enter") {
                                                            navigateWithFilters();
                                                        }
                                                    }}
                                                    style={{
                                                        marginLeft: "10px",
                                                        backgroundColor: "transparent",
                                                        color: "#fff",
                                                        borderRadius: "3px",
                                                    }}
                                                />

                                                <span className=" fs-3 position-absolute" style={{ right: 5, top: '0px', color: '#c1bfbf' }} >↵</span>
                                            </InputGroup>

                                        </div>
                                    </Form.Group>

                                    {/* Net Weight */}
                                    <Form.Group style={{ paddingTop: "10px" }}>
                                        <Form.Label
                                            style={{
                                                color: "white",
                                                fontSize: "20px",
                                                fontFamily: "Poppins",
                                            }}
                                        >
                                            Net Weightt
                                        </Form.Label>
                                        <div style={{ display: "flex", marginTop: "3px", maxWidth: '220px' }}>
                                            <InputGroup className="position-relative ">
                                                <Form.Control
                                                    type="number"
                                                    style={{
                                                        backgroundColor: "transparent",
                                                        color: "#fff",
                                                        borderRadius: "3px",
                                                    }}
                                                    name="net_weight_min"
                                                    placeholder="Min"
                                                    value={filters.net_weight_min}
                                                    onChange={handleInputChange}
                                                    onBlur={navigateWithFilters} // Trigger when field loses focus
                                                    onWheel={(e) => e.target.blur()}
                                                    onKeyDown={(e) => {
                                                        if (["ArrowUp", "ArrowDown"].includes(e.key)) {
                                                            e.preventDefault();
                                                        }
                                                        if (e.key === "Enter") {
                                                            navigateWithFilters();
                                                        }
                                                    }}
                                                />
                                                <span className=" fs-3 position-absolute" style={{ right: 5, top: '0px', color: '#c1bfbf' }} >↵</span>

                                            </InputGroup>
                                            <InputGroup className="position-relative ">
                                                <Form.Control
                                                    type="number"
                                                    name="net_weight_max"
                                                    placeholder="Max"
                                                    value={filters.net_weight_max}
                                                    onChange={handleInputChange}
                                                    onBlur={navigateWithFilters} // Trigger when field loses focus
                                                    onWheel={(e) => e.target.blur()}
                                                    onKeyDown={(e) => {
                                                        if (["ArrowUp", "ArrowDown"].includes(e.key)) {
                                                            e.preventDefault();
                                                        }
                                                        if (e.key === "Enter") {
                                                            navigateWithFilters();
                                                        }
                                                    }}
                                                    style={{
                                                        marginLeft: "10px",
                                                        backgroundColor: "transparent",
                                                        color: "#fff",
                                                        borderRadius: "3px",
                                                    }}
                                                />
                                                <span className=" fs-3 position-absolute" style={{ right: 5, top: '0px', color: '#c1bfbf' }} >↵</span>

                                            </InputGroup>
                                        </div>
                                    </Form.Group>

                                    {/* Stone Weight */}
                                    <Form.Group style={{ paddingTop: "10px" }}>
                                        <Form.Label
                                            style={{
                                                color: "white",
                                                fontSize: "20px",
                                                fontFamily: "Poppins",
                                            }}
                                        >Stone Weightt</Form.Label>
                                        <div style={{ display: "flex", maxWidth: '220px' }}>
                                            <InputGroup className="position-relative ">
                                                <Form.Control
                                                    type="number"
                                                    style={{
                                                        backgroundColor: "transparent",
                                                        color: "#fff",
                                                        borderRadius: "3px",
                                                    }}
                                                    name="stone_weight_min"
                                                    placeholder="Min"
                                                    value={filters.stone_weight_min}
                                                    onChange={handleInputChange}
                                                    onBlur={navigateWithFilters} // Trigger when field loses focus
                                                    onWheel={(e) => e.target.blur()}
                                                    onKeyDown={(e) => {
                                                        if (["ArrowUp", "ArrowDown"].includes(e.key)) {
                                                            e.preventDefault();
                                                        }
                                                        if (e.key === "Enter") {
                                                            navigateWithFilters();
                                                        }
                                                    }}
                                                />
                                                <span className=" fs-3 position-absolute" style={{ right: 5, top: '0px', color: '#c1bfbf' }} >↵</span>

                                            </InputGroup>
                                            <InputGroup className="position-relative ">
                                                <Form.Control
                                                    type="number"
                                                    name="stone_weight_max"
                                                    placeholder="Max"
                                                    value={filters.stone_weight_max}
                                                    onChange={handleInputChange}
                                                    onBlur={navigateWithFilters} // Trigger when field loses focus
                                                    onWheel={(e) => e.target.blur()}
                                                    onKeyDown={(e) => {
                                                        if (["ArrowUp", "ArrowDown"].includes(e.key)) {
                                                            e.preventDefault();
                                                        }
                                                        if (e.key === "Enter") {
                                                            navigateWithFilters();
                                                        }
                                                    }}
                                                    style={{
                                                        marginLeft: "10px",
                                                        backgroundColor: "transparent",
                                                        color: "#fff",
                                                        borderRadius: "3px",
                                                    }}
                                                />
                                                <span className=" fs-3 position-absolute" style={{ right: 5, top: '0px', color: '#c1bfbf' }} >↵</span>

                                            </InputGroup>
                                        </div>
                                    </Form.Group>

                                    {/* Apply Filters Button */}
                                    <div
                                        align="center"
                                        style={{ marginTop: "50px" }}
                                        className=""
                                    >

                                        <Button
                                            style={{
                                                backgroundColor: "#fff",
                                                color: "#23395B",
                                                boxShadow: "0px 0px 7px 0px #000",
                                                border: "none",
                                            }}
                                            className="pe-4 ps-4 mt-4 me-4"
                                            variant="light"
                                            onClick={clearFilters}
                                        >
                                            Clear Filters
                                        </Button>
                                    </div>
                                </Form>
                            </div>
                        </Offcanvas.Body>
                    </Offcanvas>

                </div>

                <motion.div
                    animate={{
                        width: showTabSidebar ? 350 : 0,
                        transition: {
                            type: "spring",
                            duration: 0.5
                        }
                    }}
                    className="d-none d-md-block"
                    style={{
                        backgroundColor: "#396D72",
                        height: "calc(100vh - 70px)",
                        marginTop: "70px",

                        overflowY: "auto",
                        position: "sticky",
                        top: "70px",
                        zIndex: 10,
                    }}
                >
                    <div
                        style={{
                            border: "none",
                            color: "#fff",
                            marginLeft: "30px",
                            fontFamily: "Roboto",
                        }}
                    >
                        <div
                            style={{
                                border: "none",
                                fontSize: "20px",
                                color: "#fff",
                                // marginLeft: "30px",
                                fontFamily: "Roboto",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                margin: "16px 0",
                            }}
                        >
                            <span>Products</span>

                            {/* <List /> */}
                            {/* <Cross fontSize={25} onClick={() => setShowTabSidebar(prev => !prev) } /> */}
                            <Hamburger toggled={showTabSidebar} onToggle={() => {
                                setShowTabSidebar(prev => !prev)
                            }} direction="right"
                                size={20} />
                        </div>
                        <Form.Check
                            type="checkbox"
                            onChange={handleCheckBoxAll}
                            checked={
                                selectedItem.length === itemData.length &&
                                itemData.length > 0
                            }
                            value=""
                            id="checkbox"
                            label="Select All Products"
                            htmlFor="checkbox"
                            className="mb-2 transparent-checkbox"
                            onClick={(e) => e.stopPropagation()}
                            style={{ cursor: "pointer" }}
                        />

                        { itemData?.length> 0 &&  itemData.map((item, index) => (
                            <Form.Check
                                key={item?.item_code}
                                type="checkbox"
                                onChange={(e) => {
                                    handleCheckNewCheckBox(e);
                                }}
                                checked={selectedItem.includes(item.item_code)}
                                name="itemName"
                                id={`item-name-${index}`}
                                value={item.item_code}
                                label={item.item_name}
                                htmlFor={`item-name-${index}`}
                                className="mb-2 transparent-checkbox"
                                onClick={(e) => e.stopPropagation()}
                            />
                        ))}
                    </div>


                    <div>
                        <Form style={{ paddingTop: "20px", marginLeft: "30px" }}>
                            {/* Size checkboxes */}
                            <Form.Group>
                                <Form.Label
                                    style={{
                                        color: "#fff",
                                        fontfamily: "Roboto",
                                        fontWeight: "500",
                                        lineHeight: "1.2",
                                        letterSpacing: "0",
                                        fontSize: "20px",
                                    }}
                                >
                                    Size
                                </Form.Label>{" "}
                                <br />
                                <div
                                    className="checks"
                                    style={{
                                        display: "flex",
                                        color: "#fff",
                                        justifyContent: "space-between",
                                        backgroundColor: "transparent",
                                    }}
                                >
                                    <div
                                        className="row"
                                        style={{
                                            marginLeft: "2px",
                                        }}
                                    >
                                        {sizes?.length > 0 && sizes.map((size, index) => (
                                            <Form.Check
                                                key={index}
                                                type="checkbox"
                                                onChange={handleCheckBoxChange}
                                                checked={AllSizes.includes(`${size}`)}
                                                name="size"
                                                id={`size-checkbox-${index}`}
                                                value={size}
                                                label={size}
                                                htmlFor={`size-checkbox-${index}`}
                                                className="mb-2 transparent-checkbox col-4"
                                            />
                                        ))}
                                    </div>
                                </div>
                            </Form.Group>

                            {/* Gross Weight */}
                            <Form.Group style={{ paddingTop: "10px", marginTop: "20px" }}>
                                <Form.Label
                                    style={{
                                        color: "#fff",
                                        fontfamily: "Roboto",
                                        fontWeight: "500",
                                        lineHeight: "1.2",
                                        letterSpacing: "0",
                                        fontSize: "20px",
                                    }}
                                >
                                    Gross Weightt
                                </Form.Label>
                                <div style={{ display: "flex", maxWidth: '220px' }}>
                                    <InputGroup className="position-relative ">
                                        <Form.Control
                                            type="number"
                                            style={{
                                                backgroundColor: "transparent",
                                                color: "#fff",
                                                borderRadius: "3px",
                                            }}
                                            name="gross_weight_min"
                                            placeholder="Min"
                                            value={filters.gross_weight_min}
                                            onChange={handleInputChange}
                                            onBlur={() => navigateWithFilters()}
                                            onWheel={(e) => e.target.blur()}
                                            onKeyDown={(e) => {
                                                if (["ArrowUp", "ArrowDown"].includes(e.key)) {
                                                    e.preventDefault();
                                                }
                                                if (e.key === "Enter") {
                                                    navigateWithFilters();
                                                }
                                            }}
                                        />

                                        <span className=" fs-3 position-absolute" style={{ right: 5, top: '0px', color: '#c1bfbf' }} >↵</span>

                                    </InputGroup>
                                    <InputGroup className="position-relative ">
                                        <Form.Control
                                            type="number"
                                            name="gross_weight_max"
                                            value={filters.gross_weight_max}
                                            placeholder="Max"
                                            onChange={handleInputChange}
                                            onBlur={() => navigateWithFilters()} // Trigger when field loses focus
                                            onWheel={(e) => e.target.blur()}
                                            onKeyDown={(e) => {
                                                if (["ArrowUp", "ArrowDown"].includes(e.key)) {
                                                    e.preventDefault();
                                                }
                                                // Trigger on Enter key
                                                if (e.key === "Enter") {
                                                    navigateWithFilters();
                                                }
                                            }}
                                            style={{
                                                marginLeft: "10px",
                                                backgroundColor: "transparent",
                                                color: "#fff",
                                                borderRadius: "3px",
                                            }}
                                        />

                                        <span className=" fs-3 position-absolute" style={{ right: 5, top: '0px', color: '#c1bfbf' }} >↵</span>
                                    </InputGroup>

                                </div>
                            </Form.Group>

                            {/* Net Weight */}
                            <Form.Group style={{ paddingTop: "10px", marginTop: "20px" }}>
                                <Form.Label
                                    style={{
                                        color: "#fff",
                                        fontfamily: "Roboto",
                                        fontWeight: "500",
                                        lineHeight: "1.2",
                                        letterSpacing: "0",
                                        fontSize: "20px",
                                    }}
                                >
                                    Net Weight
                                </Form.Label>
                                <div style={{ display: "flex", marginTop: "3px", maxWidth: '220px' }}>
                                    <InputGroup className="position-relative ">
                                        <Form.Control
                                            type="number"
                                            style={{
                                                backgroundColor: "transparent",
                                                color: "#fff",
                                                borderRadius: "3px",
                                            }}
                                            name="net_weight_min"
                                            placeholder="Min"
                                            value={filters.net_weight_min}
                                            onChange={handleInputChange}
                                            onBlur={navigateWithFilters} // Trigger when field loses focus
                                            onWheel={(e) => e.target.blur()}
                                            onKeyDown={(e) => {
                                                if (["ArrowUp", "ArrowDown"].includes(e.key)) {
                                                    e.preventDefault();
                                                }
                                                if (e.key === "Enter") {
                                                    navigateWithFilters();
                                                }
                                            }}
                                        />
                                        <span className=" fs-3 position-absolute" style={{ right: 5, top: '0px', color: '#c1bfbf' }} >↵</span>

                                    </InputGroup>
                                    <InputGroup className="position-relative ">
                                        <Form.Control
                                            type="number"
                                            name="net_weight_max"
                                            placeholder="Max"
                                            value={filters.net_weight_max}
                                            onChange={handleInputChange}
                                            onBlur={navigateWithFilters} // Trigger when field loses focus
                                            onWheel={(e) => e.target.blur()}
                                            onKeyDown={(e) => {
                                                if (["ArrowUp", "ArrowDown"].includes(e.key)) {
                                                    e.preventDefault();
                                                }
                                                if (e.key === "Enter") {
                                                    navigateWithFilters();
                                                }
                                            }}
                                            style={{
                                                marginLeft: "10px",
                                                backgroundColor: "transparent",
                                                color: "#fff",
                                                borderRadius: "3px",
                                            }}
                                        />
                                        <span className=" fs-3 position-absolute" style={{ right: 5, top: '0px', color: '#c1bfbf' }} >↵</span>

                                    </InputGroup>
                                </div>
                            </Form.Group>

                            {/* Stone Weight */}
                            <Form.Group style={{ paddingTop: "10px", marginTop: "20px" }}>
                                <Form.Label
                                    style={{
                                        color: "#fff",
                                        fontfamily: "Roboto",
                                        fontWeight: "500",
                                        lineHeight: "1.2",
                                        letterSpacing: "0",
                                        fontSize: "20px",
                                    }}
                                >
                                    Stone Weight
                                </Form.Label>
                                <div style={{ display: "flex", maxWidth: '220px' }}>
                                    <InputGroup className="position-relative ">
                                        <Form.Control
                                            type="number"
                                            style={{
                                                backgroundColor: "transparent",
                                                color: "#fff",
                                                borderRadius: "3px",
                                            }}
                                            name="stone_weight_min"
                                            placeholder="Min"
                                            value={filters.stone_weight_min}
                                            onChange={handleInputChange}
                                            onBlur={navigateWithFilters} // Trigger when field loses focus
                                            onWheel={(e) => e.target.blur()}
                                            onKeyDown={(e) => {
                                                if (["ArrowUp", "ArrowDown"].includes(e.key)) {
                                                    e.preventDefault();
                                                }
                                                if (e.key === "Enter") {
                                                    navigateWithFilters();
                                                }
                                            }}
                                        />
                                        <span className=" fs-3 position-absolute" style={{ right: 5, top: '0px', color: '#c1bfbf' }} >↵</span>

                                    </InputGroup>
                                    <InputGroup className="position-relative ">
                                        <Form.Control
                                            type="number"
                                            name="stone_weight_max"
                                            placeholder="Max"
                                            value={filters.stone_weight_max}
                                            onChange={handleInputChange}
                                            onBlur={navigateWithFilters} // Trigger when field loses focus
                                            onWheel={(e) => e.target.blur()}
                                            onKeyDown={(e) => {
                                                if (["ArrowUp", "ArrowDown"].includes(e.key)) {
                                                    e.preventDefault();
                                                }
                                                if (e.key === "Enter") {
                                                    navigateWithFilters();
                                                }
                                            }}
                                            style={{
                                                marginLeft: "10px",
                                                backgroundColor: "transparent",
                                                color: "#fff",
                                                borderRadius: "3px",
                                            }}
                                        />
                                        <span className=" fs-3 position-absolute" style={{ right: 5, top: '0px', color: '#c1bfbf' }} >↵</span>

                                    </InputGroup>
                                </div>
                            </Form.Group>

                            {/* Only keep the Clear Filters button */}
                            <div
                                align="center"
                                className="apply_button   pb-2"
                                style={{ marginTop: "20px" }}
                            >
                                <Button
                                    style={{
                                        backgroundColor: "#fff",
                                        color: "#23395B",
                                        boxShadow: "0px 0px 7px 0px #716e6e",
                                        border: "none",
                                        marginTop: '10px',
                                    }}
                                    // className="pe-4 ps-4 mt-4 me-4"
                                    variant="light"
                                    onClick={clearFilters}
                                >
                                    Clear Filters
                                </Button>
                            </div>
                        </Form>
                    </div>
                </motion.div>

                {/* //product items */}

                <motion.div
                    animate={{
                        width: !isMDDevice ? '100%' : showTabSidebar ? 'calc(100% - 350px)' : 'calc(100%)',
                        transition: {
                            type: "spring",
                            duration: 0.5
                        }
                    }}
                    style={{ marginTop: '100px' }}

                >
                    <div
                        className="d-flex  "
                        style={{

                        }}
                    >
                        {((!showTabSidebar && isMDDevice) || (!showSidebar && !isMDDevice)) &&
                            <div className="d-md-block" >


                                <Hamburger
                                    // color={(showTabSidebar || showSidebar) ? "#FFF" : "#000"}
                                    color="#000"
                                    toggled={isMDDevice ? showTabSidebar : showSidebar}
                                    onToggle={() => {
                                        isMDDevice ? setShowTabSidebar((prev) => !prev)
                                            : setShowSidebar(prev => !prev)
                                    }}
                                    direction="right"
                                    size={20}
                                />
                            </div>
                        }

                        <ProductTags
                            setDisplayData={setDisplayData}
                            fetchCartCount={fetchCartCount}
                            fetchCartItems={fetchCartItems}
                        />
                    </div>

                    <div
                        className="cart_items text-black " style={{ marginLeft: "2%", marginTop: "20px" }}
                    > Items : {(displayData || [])?.length}
                    </div>


                    <div
                        ref={scrollContainerRef}
                        style={{
                            height: "calc(100vh)",
                            overflowY: "auto",
                            scrollBehavior: "smooth",
                        }}
                    >
                        <div className="imgs-grid" >

                            {!displayData ?
                                <LoadingItemsGrid />
                                :
                                displayData.length === 0 ? (
                                    <div className="text-center">No Items Found</div>
                                ) : (
                                    displayData.map((product, index) => (
                                        <Col className="imgs-grid-item" key={product?.id}>
                                            <Card
                                                className="h-100  "
                                                style={{
                                                    borderRadius: "15px",
                                                    // borderTopRightRadius: "15px",
                                                    overflow: "hidden",
                                                    maxWidth: isLGDevice ? '280px' : 'auto',
                                                    boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        width: "100%",
                                                        height: "300px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        overflow: "hidden",
                                                    }}
                                                >

                                                    <LoadingImg
                                                        product={product}
                                                        handleNavigateToProduct={() => {
                                                            handleNavigateToProduct(product.id);
                                                        }}
                                                        onContextMenu={handleContextMenu}
                                                    />
                                                </div>

                                                <Card.Body>
                                                    <div align="center">
                                                        <h6
                                                            className="mb-1"
                                                            style={{
                                                                fontWeight: "600",
                                                                fontFamily: "Roboto",
                                                            }}
                                                        >
                                                            {product.item_tag}
                                                        </h6>
                                                        <p
                                                            className="mb-1"
                                                            style={{
                                                                fontSize: "14px",
                                                                fontWeight: "600",
                                                                fontFamily: "Roboto",
                                                            }}
                                                        >
                                                            {product.item_name}
                                                        </p>
                                                    </div>
                                                    <div
                                                        className="cart_weight"
                                                        style={{
                                                            fontSize: "13px",
                                                            fontFamily: "Roboto",
                                                            fontWeight: "400",
                                                        }}
                                                    >
                                                        <p style={{ margin: "0" }}>
                                                            Gross Wt&nbsp; :{" "}
                                                            {product.gross_weight % 1 === 0
                                                                ? product.gross_weight
                                                                : Number(product.gross_weight).toFixed(3) ||
                                                                "N/A"}{" "}
                                                            gm
                                                        </p>
                                                        <p style={{ margin: "0" }}>
                                                            Net Wt&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; :{" "}
                                                            {product.net_weight % 1 === 0
                                                                ? product.net_weight
                                                                : Number(product.net_weight).toFixed(3) ||
                                                                "N/A"}{" "}
                                                            gm
                                                        </p>
                                                        <p style={{ margin: "0" }}>
                                                            Stone Wt&nbsp; :{" "}
                                                            {product.stone_weight % 1 === 0
                                                                ? product.stone_weight
                                                                : Number(product.stone_weight).toFixed(3) ||
                                                                "N/A"}{" "}
                                                            gm
                                                        </p>
                                                        <p style={{ margin: "0" }}>
                                                            {" "}
                                                            Size&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:{" "}
                                                            {product.size || "N/A"}
                                                        </p>
                                                    </div>
                                                </Card.Body>

                                                <Button
                                                    variant="primary"
                                                    className="w-100"
                                                    style={{
                                                        backgroundColor: cartItems.includes(product.item_tag)
                                                            ? "#396D72"
                                                            : "#D1B457",
                                                        border: "none",
                                                        borderRadius: "0 0 15px 15px",
                                                    }}
                                                    onClick={() => cartItems.includes(product.item_tag) ? null : handleCartAction(product)}
                                                >
                                                    {cartItems.includes(product.item_tag) ? (
                                                        <div className="d-flex   justify-content-between mx-2 text-center">
                                                            <span className="pl-2" style={{ paddingLeft: '10px' }}  >Added to Cart</span>
                                                            <span
                                                                style={{
                                                                    backgroundColor: "transparent",
                                                                    border: "none",
                                                                    paddingTop: "0px",
                                                                    paddingBottom: "0px",
                                                                    alignItems: "center",
                                                                }}
                                                                onClick={() => handleCartActionDelete(product)}
                                                            >
                                                                <MdDelete />
                                                            </span>
                                                        </div>
                                                    ) : ("Add to Cart")}
                                                </Button>
                                            </Card>
                                        </Col>
                                    ))
                                )}

                        </div>
                    </div>
                </motion.div>
            </div>

            <hr   />

            <div
                className="address"
                style={{

                    marginTop: "30px",
                    fontFamily: "Roboto",
                    fontWeight: "500",
                    maxWidth: "600px",
                    padding: "0 20px",
                }}
            >
                <div>
                    <h3
                        style={{
                            fontSize: "22px",
                            fontFamily: "Roboto",
                            fontWeight: "500",
                            marginTop: "30px",
                            lineHeight: "1",
                            letterSpacing: "0",
                        }}
                    >
                        {companyDetails?.name}
                    </h3>
                </div>
                <div>
                    <h2
                        style={{
                            fontSize: "20px",
                            fontFamily: "Roboto",
                            fontWeight: "500",
                            marginTop: "20px",
                            lineHeight: "1",
                            letterSpacing: "0",
                        }}
                    >
                        Address
                    </h2>
                    <p style={{ fontSize: "12px", marginTop: "20px", wordWrap:'break-word', width:'220px' }}>
                        {/* Sri Shubham Jewellery, 2nd <br /> floor 201/202, mayur kushal <br />{" "}
            complex abids, Gunfoundry, <br /> Hyderabad 500001, Telegana, <br />{" "}
            India */}
                        {companyDetails?.address}
                    </p>
                </div>
                <div>
                    {(companyDetails?.whatsapp || companyDetails?.phone) &&
                        <>
                            <h2
                                style={{
                                    fontSize: "20px",
                                    fontFamily: "Roboto",
                                    fontWeight: "500",
                                    lineHeight: "1",
                                    letterSpacing: "0",
                                }}
                            >
                                Phone
                            </h2>

                            <p style={{ fontSize: "12px", marginTop: "20px" }}>{companyDetails?.phone || companyDetails?.whatsapp}</p>
                        </>
                    }
                </div>
                <div>
                    {companyDetails?.email &&
                        <>
                            <h2
                                style={{
                                    fontSize: "20px",
                                    fontFamily: "Roboto",
                                    fontWeight: "500",
                                    lineHeight: "1",
                                    letterSpacing: "0",
                                }}
                            >
                                Email
                            </h2>
                            <p style={{ fontSize: "12px", marginTop: "20px" }}>
                                {companyDetails?.email}
                            </p>

                        </>
                    }
                </div>
            </div>
            <div align="center" style={{ fontFamily: "Roboto", marginTop: "30px" }}>
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexWrap: "wrap",
                    }}
                >
                    <h4
                        align="center"
                        style={{ fontSize: "14px", marginTop: "31px", color: "#35646E" }}
                    >
                        POWERED BY
                    </h4>
                    <div
                        style={{
                            width: "100px",
                            height: "50px",
                            borderRadius: "10px",
                            overflow: "hidden",
                            alignItems: "center",
                            justifyContent: "center",
                            marginLeft: "5px", //add some space between text and logo
                        }}
                    >
                        <img
                            src={brandLogo}
                            alt="Brandlogo"
                            style={{ width: "100%", height: "100%", backgroundSize: "cover" }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Slide;
